import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { FormErrorMessage, FormSelectBox } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
  usingMonths: string[];
};

export const UsingMonthFormField = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          利用月 {props.labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <div css={fieldWrapper}>
          <FormSelectBox
            name={props.name}
            options={props.usingMonths.map((usingMonth) => ({
              value: usingMonth,
              label: usingMonth
                .substring(0, 4)
                .concat("/")
                .concat(usingMonth.substring(4, 6)),
            }))}
            registerOptions={{
              required: "選択してください",
            }}
          />
          <FormErrorMessage name={props.name} />
        </div>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "80px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  alignItems: "center",
});

const fieldWrapper = css({
  maxWidth: "200px",
});
